var App = App || {};

App.PluginExamples = (function ($) {

    'use strict';

    //function ScrollAnimate() {

    //    // typically the selector used to initalize the plugin is the widget itself
    //    // perhaps if there was significant padding on the widget, an ancestor element may be used
    //    const element = $(".widget-promos");

    //    // designers typically don't want the animation kicked off exactly as the element enters the view and waiting until halfway is too long
    //    // kick off the animations when the element is 75% from the top of the screen
    //    const offset = 75;

    //    // multiple objects within the element can be animated in different ways
    //    // optionally animations from groups of objects can be staggered
    //    const targets = [
    //        { selector: ".rich-text", type: "animate__fadeInRight", stagger: 0 },
    //        { selector: ".shared-promo-card", type: "animate__fadeInUp", stagger: 400 }
    //    ]

    //    // designs for many components lately have elements that are meant to overflow out of the component
    //    // fadeInRight (and maybe others causes a horizontal scroll bar that no one wants to see
    //    // one solution is to optionally set overflow to hidden while the animation is occurring
    //    const overflow = true;

    //    element.ZagScrollAnimate({
    //        // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
    //        offset: offset,
    //        targets: targets,
    //        overflow: overflow
    //    });
    //}

    function Parallax() {
        // please note this is for demonstration purposes only
        // within XbyK, component-specific JavaScript is typically called from within the component
        // this is done to make sure the JavaScript is fired as needed when the component is on a page OR in a modal

        // the rate at which the parallax image moves relative to scroll can be updated
        // 1: will increase the size of the image to fill the entire screen* and will appear to not move
        // 2: will increase the size of the image to 2x the size of the screen* and will move at half the rate of scroll
        // any numeric value can be used

        // * it's more intricate than that - the image is sized up to cover every vertical pixel the component may appear on
        // * so if the component is position at the top of the page and will never reach the bottom of the page, the image doesn't need to fill 100% of the browser
        // * if the component starts below the fold, the image will need to be larger than the heigh tof the browser
        const divisor = 2;

        $(".widget-masthead").each(function () {
            $(this).children(".widget-masthead-image").ZagParallax({ divisor: divisor });
        });
    }

    return {
        //ScrollAnimate: ScrollAnimate,
        Parallax: Parallax
    };

})(jQuery);

$(function () {
    //App.PluginExamples.ScrollAnimate();
    App.PluginExamples.Parallax();
});